export default {
    methods: {
        /**
         * @param {Array} options
         * @param {String} placeholderText
         */
        prependPlaceholder (options, placeholderText) {
            const placeHolderElement = {
                label: placeholderText,
                value: ''
            }

            if (!options.find((e) => e.value === placeHolderElement.value)) {
                options.unshift({
                    label: placeholderText,
                    value: ''
                })
            }

            return options
        }
    }
}
